import { store } from "../../index";

export default class ApiHelper {
  static appSettings;
}

export const LOGIN_URL = "user/login";

export const GETRESOURCES_URL = "ResourceLogic/GetResource";
export const GETRESOURCESBYDATERANGE_URL = "ResourceLogic/GetResourcesByDateRange";

export const GETTYPES_URL = "ControlType";
export const CREATENEWPROJECT = "ProjectLogic/CreateNewProject";
export const CREATENEWDATALIST = "DataListLogic/NewDataList";
export const MODIFYDATALIST = "DataListLogic/ModifyDataList";
export const DELETEDATALIST = "DataListLogic/DeleteDataList";

export const SAVETEXT = "ProjectDetailMeasurement/SaveText";
export const SAVETIME = "ProjectDetailMeasurement/SaveTime";
export const SAVECOUNT = "ProjectDetailMeasurement/SaveCount";
export const GETPROJECTS_URL = "Project/GetProjects";
export const GETPROJECTBYQR = "Project/GetProjectByQr";
export const UPDATEPROJECTS_URL = "ProjectLogic/ModifyProject";
export const UPDATEPROJECTSINGLESTOPWATCH_URL = "ProjectLogic/UpdateProjectSingleStopwatch";
export const GETMEASUREMENT_URL = "ProjectLogic/GetMeasurement";
export const GETNAME_URL = "Project/GetName";
export const GETPROJECTDETAILS_URL = "ProjectDetail/MeasurementScan";
export const GETPROJECTDETAILSBYQR_URL = "ProjectDetail/GetDetails";
export const GETMEASUREMENTBYID_URL = "ProjectLogic/GetMeasurementById";
export const GETALLPROJECTMEASUREMENTSBYID = "ProjectLogic/GetAllProjectMeasurementsById";
export const GETALLPROJECTGRAPHMEASUREMENTSBYID = "ProjectLogic/GetAllProjectGraphMeasurementsById";
export const GETALLPROJECTGRAPHMEASUREMENTSBYIDANDDATERANGE = "ProjectLogic/GetAllProjectGraphMeasurementsByIdAndDateRange";

export const GETPROJECTMEASUREMENTSBYDATEANDID = "ProjectLogic/GetProjectMeasurementsByDateAndId";
export const GET24HOURSBEFORELASTMEASUREMENTBYID = "ProjectLogic/Get24HoursBeforeLastMeasurementById";
export const GETMEASUREMENTBYIDANDDATE_URL = "ProjectLogic/GetMeasurementByIdAndDate";
export const GETMEASUREMENTSBYPROJECTID_URL = "Project/GetByProjectID";
export const GETALLPROJECTINFOBYPROJECTID = "Project/GetAllProjectInfoByProjectID";
export const GETMEASUREMENTFORMODIFY_URL = "Project/GetMeasurementForModify";
export const DELETEPROJECT = "ProjectLogic/DeleteProject";
export const GETLISTS = "DataList/GetLists";
export const GETDATALISTBYUNIQUEID = "DataList/GetDataListByUniqueId";
export const GETLISTITEMS = "DataList/GetListItems";
export const GETLISTITEMSBYLISTIDANDPROJECTGUID = "PublicDataList/GetListItemsByListIdAndProjectGuid";
export const NEWMEDIAIMAGE = "ProjectDetailMeasurementMediaLogic/SaveImage";
export const NEWMEDIAIMAGEWITHCOMMENT = "ProjectDetailMeasurementMediaLogic/SaveImageWithComment";
export const GETIMAGEBYID = "ProjectDetailMeasurementMedia/GetImageById";
export const GETSYSTEMPARAMETERS = "SystemParameter";
export const GETUSERBYEMAIL_URL = "user/GetAllByEmail";
export const GETUSERBYEMAILADDRESS = "user/GetUserByEmailAddress";
export const UPDATEUSERDATA_URL = "user/UpdateUserData";
export const UPDATEUSERLANGUAGE_URL = "user/UpdateUserLanguage";
export const CREATEUSER_URL = "UserLogic/CreateUser";
export const ADDUSER_URL = "UserLogic/AddUser";
export const UPDATEUSER_URL = "UserLogic/UpdateUser";
export const CHANGEUSERACTIVE = "UserLogic/ChangeUserActive";

export const GETALLROLES_URL = "RoleLogic/GetAll";

export const EXTERNALAPI = "ExternalApiMeasurementLogic/NewExternalApiMeasurement?ApiKey=";
export const CREATENEWAPI = "ExternalApiLogic/NewExternalApi";
export const MODIFYAPI = "ExternalApiLogic/ModifyExternalApi";
export const DELETEAPI = "ExternalApiLogic/DeleteExternalApi";
export const GETAPIS = "ExternalApi/GetApis";
export const GETEXTERNALAPIBYUNIQUEID = "ExternalApi/GetExternalApiByUniqueId";
export const GETEXTERNALAPISBYCOMPANYID = "ExternalApi/GetApisByCompanyId";
export const GETLOCATION_URL = "Project/GetAllLocation";
export const GETPROJECTNAMES_URL = "Project/GetAllProjectNames";
export const GETMEASUREMENTBYDATELOCATIONNAME = "ProjectLogic/GetMeasurementByDateLocationName";
export const GETMEASUREMENTBYDATEANDUSER = "ProjectLogic/GetProjectMeasurementsByDateAndUserId";

export const GETMEASUREMENTBYQR = "ProjectLogic/GetMeasurementByQr";
export const GETPROJECTSANDDETAILS = "ProjectLogic/GetAllProjects";
export const GETALLUSERCOMPANYPROJECTS = "ProjectLogic/GetAllUserCompanyProjects";
export const GETUSERCOMPANYPROJECTOVERVIEW = "ProjectLogic/GetUserCompanyProjectOverview";
export const GETPROJECTBYPROJECTQR = "ProjectLogic/GetProjectByProjectQr";
export const GETPROJECTBYPROJECTIDUSERID = "ProjectLogic/GetProject";
export const REQUESTLOGIN_URL = "request/RequestLogin";
export const GETVALUETYPES = "ValueType/GetAllValueTypes";

// Account
export const GETALLUSERCOMPANYACCOUNTS = "Account/GetAllUserCompanyAccounts";
export const CREATEACCOUNT = "Account/CreateAccount";
export const UPDATEACCOUNT = "Account/UpdateAccount";
export const CREATEACCOUNTS = "Account/CreateAccounts";
export const DELETEACCOUNT = "Account/DeleteAccount";
export const GETALLACCOUNTSFORGRAPHCONFIGURTATIONBYUNIQUEID = "Account/GetAllAccountsForGraphConfigurationByUniqueId";

// AccountCategory
export const GETALLUSERCOMPANYACCOUNTCATEGORIES = "AccountCategory/GetAllUserCompanyAccountCategories";
export const CREATEACCOUNTCATEGORY = "AccountCategory/CreateAccountCategory";
export const UPDATEACCOUNTCATEGORY = "AccountCategory/UpdateAccountCategory";
export const DELETEACCOUNTCATEGORY = "AccountCategory/DeleteAccountCategory";

// Company
export const SAVECOMPANY = "CompanyLogic/NewCompany"; // Create new company from duplicate company dropdown
export const CREATECOMPANY = "CompanyLogic/CreateCompany"; // Create new company the traditional way
export const MODIFYCOMPANY = "CompanyLogic/ModifyCompany";
export const GETCOMPANIES_URL = "Company/GetByUserId";
export const GETALLACTIVECOMPANIESBYUSERID = "Company/GetAllActiveUserCompanies";
export const GETCOMPANIESANDUSERSBYSUBSCRIBERUNIQUEID = "CompanyLogic/GetCompaniesAndUsersBySubscriberUniqueId";
export const GETUSERANDCOMPANYDATA_URL = "CompanyLogic/GetUserAndCompanyData";
export const SETCOMPANYSTATE = "CompanyLogic/SetCompanyState"; // Set if a company is active or inactive
export const TRANSFERCOMPANY = "CompanyLogic/TransferCompany"; // Transfer company to another subscriber
export const HIDECOMPANYFROMUSERIDBYCOMPANYID = "CompanyLogic/HideCompanyFromUserIdByCompanyId"; // Hide company from user
export const CLONECOMPANY = "CloneCompanyLogic/CloneCompany";

// CostBundleType
export const GETALLCOSTBUNDLETYPES = "CostBundleType/GetAllCostBundleTypes";

// Currency
export const GETALLCURRENCIES = "Currency/GetAllCurrencies";
export const GETCURRENCYBYID = "Currency/GetCurrencyById";

// ExternalApiType
export const GETALLEXTERNALAPITYPES = "ExternalApiType";

// ExternalApiEnumOption
export const GETENUMOPTIONS = "ExternalApiEnumOption/GetEnumOptionsByExternalApiId";
export const CREATEENUMOPTION = "ExternalApiEnumOption/NewEnumOption";
export const MODIFYENUMOPTION = "ExternalApiEnumOption/ModifyEnumOption";
export const DELETEENUMOPTION = "ExternalApiEnumOption/DeleteEnumOption";

// Financial types
export const GETALLFINANCIALTYPESBYCOMPANYID = "FinancialType/GetAllFinancialTypesByCompanyId";
export const GETALLUSERCOMPANYFINANCIALTYPES = "FinancialType/GetAllUserCompanyFinancialTypes";
export const CREATEFINANCIALTYPE = "FinancialType/CreateFinancialType";
export const UPDATEFINANCIALTYPE = "FinancialType/UpdateFinancialType";

// General Ledger Account
export const GETREPORTBYCOMPANYIDANDDATERANGE = "GeneralLedgerAccountLogic/GetReportByCompanyIdAndDateRange";
export const GETMEASUREMENTSBYCOMPANYIDANDDATERANGE = "ProjectLogic/GetMeasurementsByCompanyIdAndDateRange";

// Graph
export const GETALLLGRAPHCONFIGURATIONSBYCOMPANYID = "GraphConfiguration/GetAllGraphConfigurationsByCompanyId";
export const GETALLLGRAPHCONFIGURATIONSBYCOMPANYIDLIST = "GraphConfiguration/GetAllGraphConfigurationsByCompanyIdList";
export const GETALLUSERCOMPANYGRAPHCONFIGURATIONS = "GraphConfiguration/GetAllUserCompanyGraphConfigurations";
export const GETGRAPHCONFIGURATIONBYUNIQUEID = "GraphConfiguration/GetGraphConfigurationByUniqueId";
export const GETGRAPHCONFIGURATIONBYUNIQUEIDANDDATERANGE = "GraphConfiguration/GetGraphConfigurationByUniqueIdAndDateRange";
export const GETGRAPHCONFIGURATIONBASEBYUNIQUEID = "GraphConfiguration/GetGraphConfigurationBaseByUniqueId";
export const GETGRAPHINSIGHTS = "GraphConfiguration/GetGraphInsights";
export const GETGRAPHMEASUREMENTS = "GraphConfiguration/GetGraphMeasurements";
export const GETMEASUREMENTSPAGED = "GraphConfiguration/GetMeasurementsPaged";
export const GETGRAPHFINANCIALSUMMARY = "GraphConfiguration/GetGraphFinancialSummary";
export const GETGRAPHPROFITLOSS = "GraphConfiguration/GetGraphProfitLoss";
export const GETGRAPHCONFIGURATIONFORVIEWINGBYUNIQUEID = "PublicGraphConfiguration/GetGraphConfigurationForViewingByUniqueId";
export const GETGRAPHCONFIGURATIONFORVIEWINGBYUNIQUEIDANDDATERANGE = "PublicGraphConfiguration/GetGraphConfigurationForViewingByUniqueIdAndDateRange";
export const GETGRAPHINSIGHTSPUBLIC = "PublicGraphConfiguration/GetGraphInsights";
export const GETGRAPHMEASUREMENTSPUBLIC = "PublicGraphConfiguration/GetGraphMeasurements";
export const GETMEASUREMENTSPAGEDPUBLIC = "PublicGraphConfiguration/GetMeasurementsPaged";
export const GETGRAPHFINANCIALSUMMARYPUBLIC = "PublicGraphConfiguration/GetGraphFinancialSummary";
export const GETGRAPHPROFITLOSSPUBLIC = "PublicGraphConfiguration/GetGraphProfitLoss";
export const PUBLISHGRAPHCONFIGURATION = "GraphConfiguration/PublishGraphConfiguration";
export const DELETEGRAPHCONFIGURATION = "GraphConfiguration/DeleteGraphConfiguration";
export const CREATENEWGRAPHCONFIGURATION = "GraphConfiguration/CreateNewGraphConfiguration";
export const UPDATEGRAPHCONFIGURATION = "GraphConfiguration/UpdateGraphConfiguration";
export const GETALLPRICEBUNDLESFORGRAPHCONFIGURATIONBYUNIQUEID = "GraphConfiguration/GetAllPriceBundlesForGraphConfigurationByUniqueId";
export const GETALLPRICEBUNDLESFORGRAPHCONFIGURATIONBYUNIQUEIDPUBLIC = "PublicGraphConfiguration/GetAllPriceBundlesForGraphConfigurationByUniqueId";

// Measurements
export const GETDETAILMEASUREMENTSANDCOMMENTS = "Measurement/GetDetailsByQr";
export const GETALLMEASUREMENTSBYUSERID = "Measurement/GetAllMeasurementsByUserId";
export const SETMEASUREMENTINACTIVE = "Measurement/SetMeasurementInactive";
export const SETMEASUREMENTSINACTIVEBYIDLIST = "Measurement/SetMeasurementsInactiveByIdList";
export const SETMEASUREMENTFINISHED = "Measurement/SetMeasurementFinished";
export const SAVEMEASUREMENT = "ProjectDetailMeasurementLogic/SaveMeasurement";
export const SAVEMEASUREMENTWITHCOMMENT = "ProjectDetailMeasurementCommentLogic/SaveMeasurementWithComment";
export const SAVEANDRESETMEASUREMENTS = "ProjectDetailMeasurementLogic/SaveAndResetMeasurements";
export const UPDATEMEASUREMENT = "ProjectDetailMeasurementLogic/UpdateMeasurement";
export const GETMEASUREMENTPRICEDEFINITIONS = "ProjectDetailMeasurementLogic/GetPriceDefinitions";

// PriceBundle
export const GETALLPRICEBUNDLES = "PriceBundle/GetAllPriceBundles";
export const GETALLPROJECTAVAILABLEPRICEBUNDLES = "PriceBundle/GetAllProjectAvailablePriceBundles";
export const CREATEPRICEBUNDLE = "PriceBundle/CreatePriceBundle";
export const UPDATEPRICEBUNDLE = "PriceBundle/UpdatePriceBundle";
export const DELETEPRICEBUNDLE = "PriceBundle/DeletePriceBundle";

// PriceDefinition
export const GETALLPRICEDEFINITIONSWITHENTRIES = "PriceDefinition/GetAllPriceDefinitionsWithEntries";
export const GETALLPRICEDEFINITIONSWITHCURRENTPRICE = "PriceDefinition/GetAllPriceDefinitionsWithCurrentPrice";
export const CREATEPRICEDEFINITION = "PriceDefinition/CreatePriceDefinition";
export const UPDATEPRICEDEFINITION = "PriceDefinition/UpdatePriceDefinition";
export const SCHEDULEPRICECHANGE = "PriceDefinition/SchedulePriceChange";
export const DELETEPRICECHANGE = "PriceDefinition/DeletePriceChange";
export const DELETEPRICEDEFINITION = "PriceDefinition/DeletePriceDefinition";
export const GETPRICEHISTORY = "PriceDefinition/GetPriceHistory";
export const CORRECTPRICEENTRY = "PriceDefinition/CorrectPriceEntry";
export const UPDATEPRICEDEFINITIONSEXTERNAL = "PriceDefinitionLogic/UpdatePriceDefinitions?Key=";
export const CREATEPRICEDEFINITIONSEXTERNAL = "PriceDefinitionLogic/CreatePriceDefinitions?Key=";

// Project
export const PROJECTHASMEASUREMENTS = "ProjectLogic/ProjectHasMeasurements";

// ProjectDetail
export const PROJECTDETAILHASMEASUREMENTS = "ProjectDetail/ProjectDetailHasMeasurements";
export const UPDATEPROJECTDETAILCOSTBUNDLE = "ProjectDetail/UpdateCostBundle";
export const BULKUPDATEPROJECTDETAILCOSTBUNDLE = "ProjectDetail/BulkUpdateCostBundle";

// Subscribers
export const GETALLSUBSCRIBERS = "Subscriber/GetAllSubscribers";
export const CREATESUBSCRIBER = "Subscriber/CreateSubscriber";
export const UPDATESUBSCRIBER = "Subscriber/UpdateSubscriber";
export const GETSUBSCRIBERUSAGEBYUNIQUEIDFORDATERANGE = "Subscriber/GetSubscriberUsageByUniqueIdForDateRange";
export const SUSPENDSUBSCRIPTIONBYSUBSCRIBERUNIQUEID = "Subscriber/SuspendSubscriptionBySubscriberUniqueId";

// Subscriptions
export const GETSUBSCRIPTIONTIERBYUSERID = "Subscription/GetSubscriptionTierByUserId";
export const GETSUBSCRIPTIONBYADMINUSERID = "Subscription/GetSubscriptionByAdminUserId";
export const GETSUBSCRIPTIONBYSUBSCRIBERUNIQUEID = "Subscription/GetSubscriptionBySubscriberUniqueId";
export const GETSUBSCRIPTIONBYPROJECTQR = "Subscription/GetSubscriptionByProjectQr";
export const CHECKSUBSCRIPTIONUSERLIMITBYCOMPANYID = "Subscription/CheckSubscriptionUserLimitByCompanyId";
export const CHECKSUBSCRIPTIONCOMPANYLIMITBYCOMPANYID = "Subscription/CheckSubscriptionCompanyLimitByCompanyId";

// SubscriptionTiers
export const GETALLSUBSCRIPTIONTIERS = "SubscriptionTier/GetAllSubscriptionTiers";

// Graph Simulation Scenarios
export const GETGRAPHSIMULATIONSCENARIOS = "GraphProjectionLogic/GetScenariosForGraph";
export const CREATEGRAPHSIMULATIONSCENARIO = "GraphProjectionLogic/CreateScenario";
export const UPDATEGRAPHSIMULATIONSCENARIO = "GraphProjectionLogic/UpdateScenario";
export const DELETEGRAPHSIMULATIONSCENARIO = "GraphProjectionLogic/DeleteScenario";

// Recurring Financials
export const GETRECURRINGFINANCIALSBYCOMPANYIDSANDDATERANGE = "PriceBundle/GetRecurringFinancialsByCompanyIdsAndDateRange";

export function ComposeUri(action) {
  if (ApiHelper.appSettings) {
    return `${ApiHelper.appSettings.TAPLR_API_BASE_URL}/${action}`;
  }
}

export const getAuthHeader = (token) => {
  if (token !== null && token !== undefined && token) {
    return "Bearer " + token;
  }

  var state = store.getState();
  token = state.Login.userToken;
  return token ? "Bearer " + token : "";
};
